import {is_touch} from "../tools/helpers";

export const date_field = () => {
  const event_trigger = is_touch() ? 'touchstart' : 'focus';
  console.log(event_trigger)

  document.querySelectorAll('[name="birthdate"]').forEach(input => {
    input.setAttribute('type', 'text');

    input.addEventListener(event_trigger, event => {
      console.log('aaaa')
      input.setAttribute('type', 'date');
      input.showPicker();

    });
    input.addEventListener('blur', event => {
      if (input.value === '') {
        input.setAttribute('type', 'text');
      }
    });
  });
}
